import { loginPrefix } from '../../utils/prefix';

const Url = {
  check: `${loginPrefix}/login/check`,
  tenantInfo: `${loginPrefix}/login/tenantInfo`,
  checkAccount: `${loginPrefix}/login/checkAccount`,
  sendVerifyCode: `${loginPrefix}/login/sendVerifyCode`,
  login: `${loginPrefix}/login/action`,
  logout: `${loginPrefix}/logout/action`,
  homeDetail: `${loginPrefix}/home/detail`,
  getAreaList: `${loginPrefix}/login/get/areaList`,
  info: `${loginPrefix}/login/info`,
};

export default Url;
